//https://stackoverflow.com/questions/44447847/enums-in-javascript-with-es6
// next time use typescript, I guess?
class ChangeType {
    static #_AddressChange = 1;
    static #_NamesChange = 2;
    static #_PersonalEmail = 3;
    static #_PersonalMobilePhone = 4;
    static #_EmergencyContactChange = 5;

    static get AddressChange() { return this.#_AddressChange;}
    static get NamesChange() { return this.#_NamesChange; }
    static get PersonalEmail() {return this.#_PersonalEmail; }
    static get PersonalMobilePhone() {return this.#_PersonalMobilePhone; }
    static get EmergencyContactChange(){return this.#_EmergencyContactChange;}
}

export default ChangeType;